export default "__VITE_ASSET__CceHXJPH__"